export default "__VITE_ASSET__d275fc42__"